// src/hooks/useIsClient.ts
import { noop } from "@teamsparta/utils";
import { useSyncExternalStore } from "react";
var subscribe = () => noop;
var getSnapshot = () => true;
var getServerSnapshot = () => false;
function useIsClient() {
  const isClient = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  );
  return isClient;
}

export {
  useIsClient
};
